$(function () {
  var size = function () {
    unify('.neos-nodetypes-twocolumn .obis-site-icon-link');
    minify('.neos-nodetypes-twocolumn .obis-site-icon-link img');
    unify('.neos-nodetypes-threecolumn .obis-site-icon-link');
    minify('.neos-nodetypes-threecolumn .obis-site-icon-link img');
    unify('.neos-nodetypes-fourcolumn .obis-site-icon-link');
    minify('.neos-nodetypes-fourcolumn .obis-site-icon-link img');
    unify('.obisconcept-neosbootstrap-sixcolumn .obis-site-icon-link');
    minify('.obisconcept-neosbootstrap-sixcolumn .obis-site-icon-link img');
  }

  setTimeout(function () {
    if(!$('#neos-application').length) {
      size();

      $(window).on('resize',size);
    }
  },100);
})
